import { render, staticRenderFns } from "./ConsolidatedFlowTableButton.vue?vue&type=template&id=50ff3137&scoped=true&"
import script from "./ConsolidatedFlowTableButton.vue?vue&type=script&lang=js&"
export * from "./ConsolidatedFlowTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ff3137",
  null
  
)

export default component.exports